//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'an-stepper',
  props: {
    defaultValue: {
      type: String || Number,
      default: null,
    },
    options: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    index: 0,
  }),
  computed: {
    moreDisabled() {
      return this.index === this.options.length - 1;
    },
    lessDisabled() {
      return this.index === 0;
    },
  },
  mounted() {
    this.index = this.options.findIndex(
      (option) => option.value === this.defaultValue
    );
  },
  methods: {
    next() {
      if (this.index < this.options.length - 1) {
        this.index++;
      }
      this.$emit('select', this.options[this.index]);
    },
    previous() {
      if (this.index > 0) {
        this.index--;
      }
      this.$emit('select', this.options[this.index]);
    },
    getOption() {
      return this.options[this.index] || {};
    },
  },
};
